import { render, staticRenderFns } from "./edit-message-patterns-variable-dialog.vue?vue&type=template&id=28a7a14e&scoped=true&"
import script from "./edit-message-patterns-variable-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-message-patterns-variable-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a7a14e",
  null
  
)

export default component.exports